import { render, staticRenderFns } from "./ReportBulkSubmitter.vue?vue&type=template&id=22e96a04&scoped=true&"
import script from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
export * from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
import style0 from "./ReportBulkSubmitter.vue?vue&type=style&index=0&id=22e96a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e96a04",
  null
  
)

export default component.exports